<template>
    <div class='notFound_pg-container'>
        <el-image :src="notFoundImg" style="width: 310px; height: 264px"></el-image>
    </div>
</template>

<script>
import notFoundImg from '@/assets/images/status-404.png'

export default {
    name: 'NotFound',

    data() {
        return {
            notFoundImg
        }
    }
}
</script>

<style lang="scss" scoped>
.notFound_pg-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
